import React from "react";
import "./Accueil.css"; // si tu as déjà un CSS pour la page
import Hero from "../../Components/Hero/Hero";
import BrandsMarquee from '../../Components/BrandsMarquee/BrandsMarquee';
import Values from "../../Components/Values/Values";
import Openlift from "../../Components/Openlift/Openlift";
import Products from "../../Components/Products/Products";
import Impact from "../../Components/Impact/Impact";
import ProjectsCollab from "../../Components/ProjectsCollab/ProjectsCollab";
import Trials from "../../Components/Trials/Trials";
import WhyUs from "../../Components/WhyUs/WhyUs";
import Reveal from "../../Components/Reveal/Reveal";
import FinalCTA from "../../Components/FinalCTA/FinalCTA";

export default function Accueil() {
  return (
    <main className="page page-accueil">
      <Hero />
      <Values />
      <Openlift />
      <Products />
      <ProjectsCollab />
      <Impact />
      <Trials />
      <WhyUs />
      <FinalCTA />
      {/*<BrandsMarquee />*/}
      {/* Tu ajouteras les autres sections de la page ici */}
    </main>
  );
}
